import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloBandeira } from "../models/bandeira";
import { Repositorio } from "./repositorio";

export class RepositorioBandeira extends Repositorio<ModeloBandeira> {
  constructor() {
    super(ConstanteGlobal.BANDEIRA);
  }
}
